<template>
  <div id="regist_login">
    <div class="error_message">{{ errorMessage.text }}</div>
    <div>
      <label>ログインID（メールアドレス）</label>
    </div>
    <div class="row">
      <input
          type="text"
          v-model="form.loginId"
          placeholder="メールアドレスを入力してください"
      />
      <div class="error_message">{{ fieldErrorMessages.loginId }}</div>
    </div>
    <div>
      <label>パスワード</label>
    </div>
    <div class="row">
      <input
        type="password"
        v-model="form.password"
        placeholder="パスワードを入力してください"
      />
      <div class="error_message">{{ fieldErrorMessages.password }}</div>
    </div>
    <div class="row">
      <button class="login_btn" @click="login()">ログイン<i class='bx bx-log-in bx-sm'></i></button>
    </div>
    <div class="row">
      <button class="main_btn" @click="newUser()">新規会員登録</button>
    </div>
    <router-link to="/mmstyle/user/reset/input">パスワードをお忘れの方はこちら</router-link>
  </div>
</template>
<script>
import axios from 'axios'
import {DC_URL, DC_STORAGE_KEY} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'

export default {
  name: 'Login',
  components: {
  },
  data () {
    return {
      form: {
        loginId: '',
        password: ''
      },
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        loginId: '',
        password: ''
      }
    }
  },
  methods: {
    login: function (event) {
      // 旧データ削除
      App.removeLocalStorage(DC_STORAGE_KEY.FILE_NAME)
      App.removeLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      App.removeLocalStorage(DC_STORAGE_KEY.PRICE_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
      App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
      App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
      App.removeLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)

      App.removeLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
      App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_CHECKED)
      App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_DATA)

      let payload = {
        loginId: this.form.loginId,
        password: this.form.password
      }
      this.clearMessages()
      axios.post(DC_URL.USER, payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.errorMessage.text = response.data.errorMessage
          } else {
            // ログイン成功時ローカルストレージにユーザー情報を格納※セキュリティ上問題ないもののみ
            let data = response.data.data
            let userInfo = {
              userId: data.userId,
              corpId: data.corpId,
              corpName: data.corpName,
              userLastName: data.userLastName,
              userFirstName: data.userFirstName,
              userLastNameKana: data.userLastNameKana,
              userFirstNameKana: data.userFirstNameKana,
              userType: data.userType,
              postcd: data.postcd,
              state: data.state,
              city: data.city,
              street: data.street,
              tel: data.tel,
              userStatus: data.userStatus,
              isAccountPay: data.isAccountPay,
              isProfitFlag: data.isProfitFlag
            }
            // intercom
            let userFullName = data.userLastName + data.userFirstName
            window.intercomSettings = {
              app_id: 'APP_ID',
              name: userFullName,
              email: data.email,
              user_id: data.userId
            }
            App.setLocalStorage(DC_STORAGE_KEY.USER_INFO, userInfo)
            if (userInfo.userStatus === 'REGISTERED') {
              this.$router.push('/mmstyle/top')
            } else if (userInfo.userStatus === 'NEW') {
              this.$router.push('/mmstyle/password')
            }
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    clearMessages: function () {
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        loginId: '',
        password: ''
      }
    },
    newUser: function () {
      this.$router.push('/mmstyle/user/mail')
    }
  }
}
</script>
<style src="../../css/login.scss" lang="scss" scoped></style>
<style src="../../css/style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/login/LoginForm.vue